module.exports = __webpack_public_path__ + "static/media/GG_web_small.8ff1767e.png";